module.exports = __webpack_public_path__ + "fonts/xeicon.4ede119b.woff2";